export default "__VITE_ASSET__CDotx27r__"